import { Video, Phone } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/* Shared "choose call mode" dialog for friend invites — Camera On (video
   call) or Camera Off (audio-only phone simulation). Selecting a card
   fires onSelect("video" | "phone") and the caller runs the existing
   friend invite flow with that mode. */

const MODES = [
  {
    id: "video",
    icon: Video,
    title: "Camera On",
    desc: "Face-to-face video mock call.",
    testid: "call-mode-camera-on-btn",
  },
  {
    id: "phone",
    icon: Phone,
    title: "Camera Off",
    desc: "Audio-only phone call simulation.",
    testid: "call-mode-camera-off-btn",
  },
];

export const CallModeDialog = ({ open, onOpenChange, onSelect, friendName }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="call-mode-dialog"
      className="max-w-md border-white/10 bg-[#141414] p-6 text-white sm:rounded-3xl"
    >
      <DialogHeader>
        <DialogTitle className="font-heading text-xl font-black tracking-tight text-white">
          Choose your call mode
        </DialogTitle>
        <DialogDescription className="text-sm text-zinc-400">
          {friendName
            ? `How do you want to practise with ${friendName}?`
            : "How do you want to run this mock call?"}
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-3 sm:grid-cols-2">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            data-testid={m.testid}
            onClick={() => onSelect(m.id)}
            className="group flex flex-col items-start gap-3 rounded-2xl border border-white/10 bg-[#0F0F0F] p-5 text-left transition-colors duration-200 hover:border-[#E52525]/60 hover:bg-[#E52525]/5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#E52525]/30 bg-[#E52525]/10 text-[#E52525] transition-transform duration-200 group-hover:scale-105">
              <m.icon size={20} />
            </span>
            <span>
              <span className="block text-sm font-bold text-white">
                {m.title}
              </span>
              <span className="mt-1 block text-xs font-light leading-relaxed text-zinc-400">
                {m.desc}
              </span>
            </span>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
